import { c as _c } from "react/compiler-runtime";
import { readFragment } from "@opensea/graphql";
import { getProfileUrl } from "@/components/account/utils";
import { getCollectionUrl } from "@/components/collection/utils";
import { useCurrencyUrl } from "@/components/currencies/use-currency-url";
import { itemUrl } from "@/components/items/utils";
import { ExpandedSearch_accountFragment, ExpandedSearch_collectionFragment, ExpandedSearch_currencyFragment, ExpandedSearch_itemFragment } from "../ExpandedSearch.fragment";
function getHrefForAccount(data) {
  const account = readFragment(ExpandedSearch_accountFragment, data);
  return getProfileUrl(account);
}
function getHrefForCollection(data) {
  const collection = readFragment(ExpandedSearch_collectionFragment, data);
  return getCollectionUrl(collection);
}
function getHrefForItem(data) {
  const item = readFragment(ExpandedSearch_itemFragment, data);
  return itemUrl(item);
}
export function useGetHrefForExpandedSearchResultItem() {
  const $ = _c(2);
  const {
    getCurrencyUrl
  } = useCurrencyUrl();
  let t0;
  if ($[0] !== getCurrencyUrl) {
    t0 = item => {
      switch (item.type) {
        case "link":
          {
            return item.data.href;
          }
        case "account":
          {
            return getHrefForAccount(item.data);
          }
        case "collection":
          {
            return getHrefForCollection(item.data);
          }
        case "item":
          {
            return getHrefForItem(item.data);
          }
        case "currency":
          {
            const currency = readFragment(ExpandedSearch_currencyFragment, item.data);
            return getCurrencyUrl(currency);
          }
        case "recent-search":
          {
            switch (item.data.type) {
              case "account":
                {
                  return getHrefForAccount(item.data.data);
                }
              case "collection":
                {
                  return getHrefForCollection(item.data.data);
                }
              default:
                {
                  return null;
                }
            }
          }
        default:
          {
            return null;
          }
      }
    };
    $[0] = getCurrencyUrl;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}